module.exports = __webpack_public_path__ + "static/media/14@1280w.38b89e8e.jpg";